function fn_layout_header() {
    var $fn = $("#layout_header"),
        $nav = $("#layout_nav");

    if ($fn.length) {
        $('.ssm-nav').slideAndSwipe();
        var $lang = $fn.find(".elm_lang ul").clone(),
            $book = $fn.find(".elm_book").clone();

        $nav.find(".elm_content .elm_nav").append($lang);
        $nav.prepend($book);

        if (!$fn.hasClass("mod--booking")) {
            var headroom = new Headroom($fn[0], {
                offset: 5,
                tolerance : {
                    up : 5,
                    down : 0
                },
                classes: {
                    "initial" : "headroom",
                    "pinned": "headroom--pinned",
                    "unpinned": "headroom--unpinned",
                    "top" : "headroom--top",
                    "notTop" : "headroom--not-top"
                }
            });
            headroom.init();
        }
    }
}